import { fetch } from './fetch';

export const fetchInvoices = fetch('FETCH_INVOICES', 'gt/customer/invoices/');
